import React from "react";
import AlgorandLogoIcon from "theme/icons/AlgorandLogo";
import DollarSignIcon from "theme/icons/DollarSign";
import EuroIcon from "theme/icons/Euro";
import GBPIcon from "theme/icons/GBP";

const Currencies = (colorCode, currencyCode) => {
	const currentCurrency = {
		algo: {
			icon: <AlgorandLogoIcon fill={colorCode} />,
			"currency-code": "algo",
			language: "Algo",
		},
		usd: {
			icon: <DollarSignIcon fill={colorCode} />,
			"currency-code": "usd",
			language: "US Dollar",
		},
		eur: {
			icon: <EuroIcon fill={colorCode} />,
			"currency-code": "eur",
			language: "Euro",
		},
		gbp: {
			icon: <GBPIcon fill={colorCode} />,
			"currency-code": "gbp",
			language: "Pound",
		},
	};

	return currentCurrency[currencyCode];
};

export default Currencies;
